export const BASIC_USER_INFO = "basic_user_info";
